import React from "react";
import "./Sidebar.css";

const Sidebar = () => {
  const links = [
    {
      href: "http://piper-ears.web.app",
      title: "Piper Ears",
      alt: "Link to Piper Ears ear training app"
    },
    {
      href: "http://piper-keys.web.app",
      title: "Piper Keys",
      alt: "Link to Piper Keys key signatures app"
    },
    {
      href: "http://piper-extras.web.app",
      title: "Printable Worksheets",
      alt: "Link to Piper printable worksheets"
    },
    {
      href: "http://piper-extras.web.app",
      title: "Videos",
      alt: "Link to Piper Videos"
    }
  ];

return (
    <div className="sidebar-container">
        {links.map((link) => (
            <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="sidebar-link"
            >
                {link.title}
            </a>
        ))}
    </div>
);
};

export default Sidebar;
